module.exports = __webpack_public_path__ + "img/33-33-33.fa20206d.svg";